import {ILauncherService} from './launcher.service.interface';
import {LauncherOverrides} from '../../app-bootstrap/config-interfaces/launcher-overrides';
import {Check} from '@sparkware/app-utils';
import {ServiceBase} from '../ServiceBase';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import {LauncherOverridesReader} from '../../app-bootstrap/launcher-overrides-reader/launcher-overrides-reader';

export class LauncherService extends ServiceBase implements ILauncherService{

    private _launcherOverrides: LauncherOverrides;


    constructor(services: IServiceFactoryExtended){
      super(services);
      let launcherOverridesReader = new LauncherOverridesReader(this.services.storage, this.services.logger);
      this._launcherOverrides = launcherOverridesReader.getOverrides() || {};

    }

    getCMSOrigin(): string | undefined {
      return this._launcherOverrides.orbit &&  this._launcherOverrides.orbit.cmsSource;
    }

    getTestedGames(): number[] {

      let gameTypes = this._launcherOverrides.orbit &&  this._launcherOverrides.orbit.addedGameTypesFromSdm;
      if(!gameTypes) {
        return [];
      }

      if(Check.isNumber(gameTypes)) { // it means that the launcher gave us a single game
        return [gameTypes];
      }

      if(Check.isString(gameTypes)) {
        return gameTypes.split(',').map(gt => parseInt(gt)).filter(gt => Check.isNumber(gt));
      }

      if(Check.isArray(gameTypes)) {
        return gameTypes.map(gt => parseInt(String(gt))).filter(gt => Check.isNumber(gt));
      }

      return [];
    }

    getSegmentsOverride(): Record<string, boolean> {
        return this._launcherOverrides?.webData?.segments || {};
    }
}
